class ProductsSlider {
    constructor() {
        this.sliderTrack = document.querySelector('[data-slider-track]');
        this.prevButton = document.querySelector('[data-slider-prev]');
        this.nextButton = document.querySelector('[data-slider-next]');
        this.items = this.sliderTrack?.querySelectorAll('.dl-products-slider__item') || [];

        if (!this.sliderTrack || this.items.length === 0) return;

        this.currentIndex = 0;
        this.isMobile = window.innerWidth <= 768;
        // this.blocksPerView = this.isMobile ? 1 : 4;

        // 初始设置maxIndex，后续会在init()中重新计算
        this.maxIndex = Math.max(0, this.items.length - 1);

        // PC端特殊配置
        this.itemWidth = 0;
        this.gap = 25; // 25px gap，与CSS保持一致
        // this.maxContainerWidth = 1280; // 最大容器宽度

        // 移动端配置
        this.mobileGap = 15; // 移动端gap

        // 移动端滑动相关
        this.isAnimating = false;
        this.lastSwipeTime = 0;
        this.swipeCooldown = 300; // 滑动冷却时间（毫秒）

        this.init();
        this.bindEvents();
    }

    init() {
        // 计算项目宽度
        this.calculateItemWidth();

        // 重新计算最大索引（基于实际宽度）
        this.calculateMaxIndex();

        // 初始化按钮状态和显示逻辑
        this.updateButtonStates();
        this.updateButtonVisibility();

        // 设置初始位置
        this.setInitialPosition();

        // 更新置灰效果
        this.updateActiveStates();

        // 移动端不再需要触摸滑动，由CSS Grid控制两列布局
        // if (this.isMobile) {
        //     this.enableTouchSwipe();
        // }

        // 确保初始transform设置正确
        this.updateSlider();
    }

    calculateItemWidth() {
        if (this.isMobile) {
            // 移动端：由CSS Grid控制，不再计算固定宽度
            this.itemWidth = 0;
        } else {
            // PC端：根据屏幕宽度确定产品卡片宽度
            if (window.innerWidth > 1280) {
                this.itemWidth = 410; // 大于1280px：大尺寸产品卡片
            } else if (Math.abs(window.innerWidth - 1280) < 1) {
                // 1280px屏幕：使用合适的卡片宽度
                this.itemWidth = 410; // 固定使用410px，三个卡片 + 两个间距 = 410*3 + 25*2 = 1280px，刚好填满屏幕
            } else if (window.innerWidth >= 769) {
                this.itemWidth = 280; // 中等屏幕
            } else {
                this.itemWidth = 280; // 默认
            }
        }

        // 应用宽度到所有产品卡片
        this.applyItemWidth();
    }

    applyItemWidth() {
        if (this.isMobile) {
            this.items.forEach(item => {
                item.style.width = '';
                item.style.flexShrink = '';
                item.style.flexGrow = '';
            });
            return;
        }

        // 为所有产品卡片设置统一的宽度
        this.items.forEach(item => {
            item.style.width = `${this.itemWidth}px`;
            item.style.flexShrink = '0';
            item.style.flexGrow = '0';
        });
    }

    calculateMaxIndex() {
        if (this.isMobile) {
            // 移动端可以滑动到最后一个产品
            this.maxIndex = Math.max(0, this.items.length - 1);
        } else {
            // PC端基于实际宽度计算最大索引
            if (!this.sliderTrack || !this.sliderTrack.parentElement) {
                this.maxIndex = Math.max(0, this.items.length - 1);
                return;
            }

            const sliderTrackWidth = this.items.length * (this.itemWidth + this.gap) - this.gap;
            const containerWidth = this.sliderTrack.parentElement.clientWidth;

            // 如果内容宽度小于等于容器宽度，不需要滑动
            if (sliderTrackWidth <= containerWidth) {
                this.maxIndex = 0;
            } else {
                // 计算能滑动的最大索引
                const maxTranslateDistance = sliderTrackWidth - containerWidth;
                const maxSteps = Math.floor(maxTranslateDistance / (this.itemWidth + this.gap));
                this.maxIndex = Math.min(maxSteps + 1, this.items.length - 1);
            }
        }
    }

    setInitialPosition() {
        let documentWidth = document.documentElement.clientWidth;
        if (!this.isMobile) {
            if (documentWidth > 1280) {
                // 屏幕宽度 > 1280px：让第一个产品显示在1280px容器的最左侧
                // const screenCenterOffset = (documentWidth - 1280) / 2;
                // this.sliderTrack.style.transform = `translateX(${screenCenterOffset}px)`;
            } else if (Math.abs(documentWidth - 1280) < 1) {
                // 屏幕宽度 ≈ 1280px：刚好显示三个产品，不需要偏移
                // this.sliderTrack.style.transform = 'translateX(0px)';
            } else {
                // 屏幕宽度 < 1280px：让三个产品在屏幕中间显示
                // const totalWidth = (this.itemWidth * 3) + (this.gap * 2);
                // const centerOffset = (documentWidth - totalWidth) / 2;
                // this.sliderTrack.style.transform = `translateX(${centerOffset}px)`;
            }
        } else {
            // 移动端：重置transform为none，由CSS自然排版
            this.sliderTrack.style.transform = 'none';
        }
    }

    updateActiveStates() {
        if (this.isMobile) return; // 移动端不置灰

        this.items.forEach((item, index) => {
            // 判断当前项目是否在显示区域内（当前索引到当前索引+2）
            const isActive = index >= this.currentIndex && index < this.currentIndex + this.blocksPerView;

            if (isActive) {
                item.classList.add('dl-products-slider__item--active');
            } else {
                item.classList.remove('dl-products-slider__item--active');
            }
        });
    }

    bindEvents() {
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.prev());
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.next());
        }

        // 响应式处理
        window.addEventListener('resize', this.handleResize.bind(this));

        // 键盘导航支持
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    prev() {
        if (this.currentIndex > 0 && !this.isAnimating) {
            this.currentIndex--;
            this.updateSlider();
        }
    }

    next() {
        if (this.currentIndex < this.maxIndex && !this.isAnimating) {
            this.currentIndex++;
            this.updateSlider();
        }
    }

    updateSlider() {
        let documentWidth = document.documentElement.clientWidth;
        if (!this.sliderTrack) return;

        this.isAnimating = true;

        if (this.isMobile) {
            // 移动端由 CSS Grid 排版，无需滑动
            this.sliderTrack.style.transition = 'none';
            this.sliderTrack.style.transform = 'none';
            this.isAnimating = false;
        } else {

            const screenCenterOffset = 0;
            let translateX = screenCenterOffset - (this.currentIndex * (this.itemWidth + this.gap));

            // 计算最大滑动宽度：sliderTrack总宽度 - 父容器宽度
            const sliderTrackWidth = this.items.length * (this.itemWidth + this.gap) - this.gap;
            const containerWidth = this.sliderTrack.parentElement.clientWidth;
            const maxTranslateX = Math.min(0, -(sliderTrackWidth - containerWidth + this.gap * 2));

            // 限制滑动范围：不能向左滑动超过最大宽度，不能向右滑动超过0
            translateX = Math.max(maxTranslateX, Math.min(0, translateX));

            this.sliderTrack.style.transform = `translateX(${translateX}px)`;

            this.isAnimating = false;
        }

        this.updateButtonStates();
        this.updateActiveStates();
    }

    updateButtonStates() {
        if (this.prevButton) {
            this.prevButton.disabled = this.currentIndex === 0;
            this.prevButton.setAttribute('aria-disabled', this.currentIndex === 0);
        }

        if (this.nextButton) {
            this.nextButton.disabled = this.currentIndex > this.maxIndex;
            this.nextButton.setAttribute('aria-disabled', this.currentIndex >= this.maxIndex);
        }
    }

    updateButtonVisibility() {
        // PC端：当产品数量大于3个时显示按钮
        // 移动端：始终隐藏按钮
        const shouldShowButtons = !this.isMobile && this.items.length > 3;

        if (this.prevButton) {
            //this.prevButton.style.display = shouldShowButtons ? 'flex' : 'none';
        }

        if (this.nextButton) {
            //this.nextButton.style.display = shouldShowButtons ? 'flex' : 'none';
        }
    }

    handleResize() {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 768;
        this.blocksPerView = this.isMobile ? 1 : 3; ``

        // 重新计算项目宽度
        this.calculateItemWidth();

        // 重新计算最大索引（基于新的宽度）
        this.calculateMaxIndex();

        // 更新按钮可见性
        this.updateButtonVisibility();

        // 如果从PC切换到移动端或反之，重置位置
        if (wasMobile !== this.isMobile) {
            this.currentIndex = 0;
            this.setInitialPosition();
            this.updateSlider();

            // 重新绑定触摸事件（已在移动端取消滑动，可忽略）
            // if (this.isMobile) {
            //     this.enableTouchSwipe();
            // }
        } else {
            // 同设备类型，只更新位置
            this.updateSlider();
        }

        // 确保transform设置正确
        this.updateSlider();
    }

    handleKeydown(event) {
        // 只在轮播区域获得焦点时响应键盘事件
        const isSliderFocused = this.sliderTrack?.contains(document.activeElement);
        if (!isSliderFocused) return;

        switch (event.key) {
            case 'ArrowLeft':
                event.preventDefault();
                this.prev();
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.next();
                break;
            case 'Home':
                event.preventDefault();
                this.currentIndex = 0;
                this.updateSlider();
                break;
            case 'End':
                event.preventDefault();
                this.currentIndex = this.maxIndex;
                this.updateSlider();
                break;
        }
    }

    enableTouchSwipe() {
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;
        let isDragging = false;
        let startTime = 0;
        let initialTransform = 0;

        const handleTouchStart = (e) => {
            if (this.isAnimating) return; // 动画期间不响应触摸

            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startTime = Date.now();
            isDragging = true;

            // 使用计算出的期望transform值，而不是getComputedStyle
            // 这样可以避免动画过渡期间获取到错误的transform值
            // 移动端需要考虑gap间距，最后一个产品需要右对齐
            let expectedTransform = -(this.currentIndex * (this.itemWidth + this.mobileGap));

            // 如果是最后一个产品，需要右对齐
            if (this.currentIndex === this.maxIndex && this.maxIndex > 0) {
                const containerWidth = window.innerWidth - 48;
                const lastItemOffset = containerWidth - this.itemWidth;
                expectedTransform = -(this.maxIndex * (this.itemWidth + this.mobileGap)) + lastItemOffset;
            }

            initialTransform = expectedTransform;

            // 移除过渡动画，实现跟随手指移动
            this.sliderTrack.style.transition = 'none';

            // 添加滑动状态样式
            this.sliderTrack.classList.add('dl-products-slider__track--dragging');
        };

        const handleTouchMove = (e) => {
            if (!isDragging || this.isAnimating) return;

            currentX = e.touches[0].clientX;
            currentY = e.touches[0].clientY;

            const diffX = currentX - startX;
            const diffY = currentY - startY;

            // 如果水平滑动距离大于垂直滑动距离，阻止页面滚动
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
                e.preventDefault();

                // 计算新的transform位置，添加阻尼效果和边界限制
                const damping = 0.8; // 阻尼系数
                let newTransform = initialTransform + (diffX * damping);

                // 边界限制：不允许滑动超出范围
                const maxTransform = 0; // 最右边（第一个产品）

                // 最左边（最后一个产品）需要考虑右对齐
                let minTransform = -(this.maxIndex * (this.itemWidth + this.mobileGap));
                if (this.maxIndex > 0) {
                    const containerWidth = window.innerWidth - 48;
                    const lastItemOffset = containerWidth - this.itemWidth;
                    minTransform = -(this.maxIndex * (this.itemWidth + this.mobileGap)) + lastItemOffset;
                }

                // 应用边界限制
                newTransform = Math.max(minTransform, Math.min(maxTransform, newTransform));

                this.sliderTrack.style.transform = `translateX(${newTransform}px)`;
            }
        };

        const handleTouchEnd = () => {
            if (!isDragging || this.isAnimating) return;

            isDragging = false;

            // 移除滑动状态样式
            this.sliderTrack.classList.remove('dl-products-slider__track--dragging');

            const currentTime = Date.now();
            const timeDiff = currentTime - startTime;

            // 检查滑动冷却时间
            if (currentTime - this.lastSwipeTime < this.swipeCooldown) {
                // 恢复原位置
                this.updateSlider();
                return;
            }

            const diffX = startX - currentX;
            const diffY = startY - currentY;
            const threshold = 60; // 增加最小滑动距离
            const velocityThreshold = 0.5; // 增加速度阈值
            const velocity = Math.abs(diffX) / timeDiff;

            // 判断是否应该切换：距离足够 或 速度足够快
            const shouldSwitch = (Math.abs(diffX) > Math.abs(diffY) &&
                (Math.abs(diffX) > threshold || velocity > velocityThreshold));

            if (shouldSwitch) {
                this.lastSwipeTime = currentTime;

                if (diffX > 0) {
                    this.next();
                } else {
                    this.prev();
                }
            } else {
                // 如果没有切换，恢复当前位置
                this.updateSlider();
            }
        };

        // 移除之前的事件监听器（如果存在）
        this.sliderTrack.removeEventListener('touchstart', handleTouchStart);
        this.sliderTrack.removeEventListener('touchmove', handleTouchMove);
        this.sliderTrack.removeEventListener('touchend', handleTouchEnd);

        // 添加新的事件监听器
        this.sliderTrack.addEventListener('touchstart', handleTouchStart, { passive: false });
        this.sliderTrack.addEventListener('touchmove', handleTouchMove, { passive: false });
        this.sliderTrack.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
}

// 初始化轮播
document.addEventListener('DOMContentLoaded', () => {
    new ProductsSlider();
});

// 支持多个轮播实例
document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-slider-track]')) {
        new ProductsSlider();
    }
}); 